import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Home, ShoppingCart, Trash2 } from 'lucide-react';
import { products as mockProducts } from '../mock';
import { useProducts } from '../context/ProductsContext';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../lib/format';

const Favorites = () => {
  const { favorites, toggleFavorite, addToCart } = useCart();
  const { products: apiProducts } = useProducts();
  const products = apiProducts.length ? apiProducts : mockProducts;
  const items = products.filter((p) => favorites.includes(p.id));

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-neutral-50 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 py-3 text-sm flex items-center gap-2 text-neutral-500">
          <Link to="/" className="hover:text-amber-600 flex items-center gap-1">
            <Home className="w-3.5 h-3.5" /> Acasă
          </Link>
          <span>/</span>
          <span className="text-neutral-900">Favorite</span>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl md:text-4xl font-serif font-bold text-neutral-900 mb-2">Lista mea de favorite</h1>
        <p className="text-neutral-500 mb-8">{items.length} {items.length === 1 ? 'produs salvat' : 'produse salvate'}</p>

        {items.length === 0 ? (
          <div className="text-center py-20 bg-neutral-50 rounded-2xl border border-dashed border-neutral-300">
            <Heart className="w-16 h-16 text-neutral-300 mx-auto mb-4" />
            <p className="text-neutral-600">Nu ai încă produse favorite</p>
            <Link to="/magazin" className="inline-block mt-5 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white rounded-full text-sm font-medium">
              Explorează magazinul
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((p) => (
              <div key={p.id} className="flex gap-4 bg-white border border-neutral-200 rounded-2xl p-4 hover:shadow-md transition">
                <Link to={`/produs/${p.slug}`} className="shrink-0">
                  <img src={p.image} alt={p.name} className="w-28 h-28 rounded-lg object-cover bg-neutral-50" />
                </Link>
                <div className="flex-1 flex flex-col">
                  <span className="text-xs uppercase tracking-wider text-amber-600">{p.categoryName}</span>
                  <Link to={`/produs/${p.slug}`}>
                    <h3 className="font-medium text-neutral-900 hover:text-amber-700 mt-1 line-clamp-2">{p.name}</h3>
                  </Link>
                  <div className="mt-auto flex items-end justify-between gap-2">
                    <span className="text-lg font-bold text-neutral-900">{formatPrice(p.price)}</span>
                    <div className="flex items-center gap-2">
                      <button onClick={() => toggleFavorite(p.id)} className="w-9 h-9 rounded-full border border-neutral-200 text-neutral-500 hover:text-red-500 hover:border-red-300 flex items-center justify-center">
                        <Trash2 className="w-4 h-4" />
                      </button>
                      <button onClick={() => addToCart(p)} className="inline-flex items-center gap-1.5 bg-neutral-900 hover:bg-amber-500 text-white text-xs font-medium px-3 py-2 rounded-full">
                        <ShoppingCart className="w-3.5 h-3.5" /> În coș
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
